import React, { useState } from "react";
import { TextField, Alert } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import apiUrl from "../api";

import axios from "axios";

const AddVendor = () => {
  const [vendorName, setVendorName] = useState("");
  const [vendorPhone, setVendorPhone] = useState("");
  const [vendorTaxId, setVendorTaxId] = useState("");

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const user = JSON.parse(localStorage.getItem("user"));

  const handleAddVendor = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (vendorName === "") {
      return setError("Vendor name is required.");
    }

    // Add your API call here to add the vendor
    try {
      await axios.post(
        `${apiUrl}/vendor/`,
        {
          name: vendorName,
          phone: vendorPhone,
          tax_id: vendorTaxId,
        },
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );

      setSuccess("Vendor added successfully.");
    } catch (error) {
      if (error.response && error.response.status === 409) {
        setError("Vendor with this Tax ID already exists.");
      } else {
        setError("Failed to add Vendor. Please try again.");
      }
    }

    setVendorName("");
    setVendorPhone("");
    setVendorTaxId("");
  };

  return (
    <div className="add-category-option-wrapper">
      {error && <Alert severity="error">{error}</Alert>}
      {success && <Alert severity="success">{success}</Alert>}
      <h4
        style={{
          marginBottom: "0px",
          fontWeight: "600",
        }}
      >
        Add Vendor
      </h4>
      <form
        onSubmit={handleAddVendor}
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          width: "100%",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            width: "100%",
            alignItems: "center",
          }}
        >
          <TextField
            variant="outlined"
            label="Vendor Name"
            placeholder="Vendor Name"
            value={vendorName}
            onChange={(e) => setVendorName(e.target.value)}
            fullWidth
            margin="normal"
            InputProps={{
              inputProps: { style: { height: "56px", padding: "5px" } },
            }}
          />
          <TextField
            variant="outlined"
            label="Phone Number"
            placeholder="Phone Number"
            value={vendorPhone}
            onChange={(e) => setVendorPhone(e.target.value)}
            fullWidth
            margin="normal"
            InputProps={{
              inputProps: { style: { height: "56px", padding: "5px" } },
            }}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            width: "100%",
            alignItems: "center",
          }}
        >
          <TextField
            variant="outlined"
            label="Tax ID"
            placeholder="Tax ID"
            value={vendorTaxId}
            onChange={(e) => setVendorTaxId(e.target.value)}
            fullWidth
            margin="normal"
            InputProps={{
              inputProps: { style: { height: "56px", padding: "5px" } },
            }}
          />
          <button
            className="add-ticket-button__button"
            sx={{
              backgroundColor: "var(--primary-color)",
              color: "var(--primary-text-color)",
              fontSize: "15px",
              fontWeight: "600",
              width: "auto",
              padding: "10px 20px",
            }}
            onClick={() => {}}
          >
            <AddIcon />
            <span>Add</span>
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddVendor;
